import React from "react";
import { QuoteContext } from "../state/quote-context";

export default function useQuote() {
  const context = React.useContext(QuoteContext);

  if (context === undefined) {
    throw new Error("useQuote must be used within a QuoteContextProvider");
  }

  return context;
}
